export var MAX_VISIBLE_SUGGESTIONS_DESKTOP = 5;
export var MAX_VISIBLE_SUGGESTIONS_MOBILE = 10;
export var DEVIATION_SUGGESTIONS_I18N_KEYS = [
    'commentbox.suggestions.deviation.1',
    'commentbox.suggestions.deviation.2',
    'commentbox.suggestions.deviation.3',
    'commentbox.suggestions.deviation.4',
    'commentbox.suggestions.deviation.5',
    'commentbox.suggestions.deviation.6',
    'commentbox.suggestions.deviation.7',
    'commentbox.suggestions.deviation.8',
    'commentbox.suggestions.deviation.9',
    'commentbox.suggestions.deviation.10',
    'commentbox.suggestions.deviation.11',
    'commentbox.suggestions.deviation.12',
    'commentbox.suggestions.deviation.13',
    'commentbox.suggestions.deviation.14',
    'commentbox.suggestions.deviation.15',
    'commentbox.suggestions.deviation.16',
    'commentbox.suggestions.deviation.17',
    'commentbox.suggestions.deviation.18',
    'commentbox.suggestions.deviation.19',
    'commentbox.suggestions.deviation.20',
    'commentbox.suggestions.deviation.21',
    'commentbox.suggestions.deviation.22',
];
export var PROFILE_SUGGESTIONS_I18N_KEYS = [
    'commentbox.suggestions.profile.1',
    'commentbox.suggestions.profile.2',
    'commentbox.suggestions.profile.3',
    'commentbox.suggestions.profile.4',
    'commentbox.suggestions.profile.5',
    'commentbox.suggestions.profile.6',
    'commentbox.suggestions.profile.7',
    'commentbox.suggestions.profile.8',
    'commentbox.suggestions.profile.9',
    'commentbox.suggestions.profile.10',
    'commentbox.suggestions.profile.11',
    'commentbox.suggestions.profile.12',
    'commentbox.suggestions.profile.13',
    'commentbox.suggestions.profile.14',
    'commentbox.suggestions.profile.15',
    'commentbox.suggestions.profile.16',
    'commentbox.suggestions.profile.17',
    'commentbox.suggestions.profile.18',
    'commentbox.suggestions.profile.19',
    'commentbox.suggestions.profile.20',
];
//# sourceMappingURL=constants.js.map